import { useState } from "react";
import Table from "../../components/Table/index.jsx";
import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ALL_FRANCHISE, VERIFY_FRANCHISE } from "../../graphql/Query/GETALLFRANCHISELIST.js";
import { toast } from "react-toastify";
import { FaEye, FaPlusCircle } from "react-icons/fa";
import FranchiseDepositeAddModal from "./FranchiseDepositeAddModels.js";

const TotalFranchiseAdmin = () => {
    const [showModal, setShowModal] = useState(false);
    const [modalImage, setModalImage] = useState("");


    const handleOpenModal = (imageUrl) => {
        setModalImage(imageUrl);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalImage("");
    };


    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const [formData, setFormData] = useState({
        fromDate: "",
        toDate: "",
        awbNo: "",
        SenderName: "",
        type: "all",
    });

    const handleChange = (e) => {
        const { name, value } = e?.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleReset = () => {
        setFormData({
            fromDate: "",
            toDate: "",
            awbNo: "",
            SenderName: "",
            type: "all",
        });
    };
    const { data, loading } = useQuery(GET_ALL_FRANCHISE, {
        variables: {
            page,
            limit,
            sort: { key: "createdAt", type: -1 },
            from: formData?.fromDate || null,
            to: formData?.toDate || null,
            search: formData?.awbNo
            // filter: formData?.email || formData?.Id || formData?.Name || formData?.contact || null,
        },
        fetchPolicy: "cache-and-network"
    });
    const [verifyFranchise, { loading: verifyLoading }] = useMutation(VERIFY_FRANCHISE, {
        refetchQueries: ["GetAllFranchise"], // or use your GET_ALL_FRANCHISE query name
        awaitRefetchQueries: true,
    });

    const handleVerifyFranchise = async (franchiseId) => {
        try {
            const confirmed = window.confirm("Are you sure you want to verify this franchise?");
            if (!confirmed) return;

            const { data } = await verifyFranchise({
                variables: { franchiseId },
            });

            toast.success("Franchise verified successfully!");
            console.log("✅ Verified:", data?.verifyFranchise);
        } catch (error) {
            console.error("❌ Verification failed:", error);
            toast.error(error.message || "Failed to verify franchise");
        }
    };

    const orderTableColumns = [
        {
            name: "No",
            selector: (row, index) => (
                <span className="text-xs text-gray-700">{index + 1}</span>
            ),
            width: "60px",
        },
        {
            name: "Created Date",
            sortable: true,
            selector: (row) => {
                const date = new Date(row?.createdAt);
                return <span className="text-xs">{date.toLocaleDateString()}</span>;
            },
            width: "120px",
        },
        {
            name: "Franchise Name",
            sortable: true,
            selector: (row) => row?.fullName || "-",
            cell: (row) => (
                <div
                    className="truncate max-w-xs cursor-pointer text-xs"
                    title={`Name: ${row?.fullName || "-"}\nEmail: ${row?.email || "-"
                        }\nPhone: ${row?.contactNo || "-"}`}
                >
                    {row?.fullName || "-"}
                </div>
            ),
        },
        {
            name: "Franchise Office Details",
            sortable: true,
            selector: (row) => row?.officePincode || "-",
            cell: (row) => (
                <div
                    className="truncate max-w-xs cursor-pointer text-xs"
                    title={`Name: ${row?.officeAddress || "-"}\nofficeMainArea: ${row?.officeMainArea || "-"
                        }\nofficeCity: ${row?.officeCity || "-"}\noofficeState: ${row?.officeState || "-"} \nodistrict: ${row?.district || "-"}\noofficeTelephoneNo: ${row?.officeTelephoneNo || "-"}`}
                >
                    {row?.officePincode || "-"}
                </div>
            ),
        },
        {
            name: "Franchise ID",
            sortable: true,
            selector: (row) => row?.username || "-",
            cell: (row) => (
                <span className="text-xs font-medium text-blue-600 cursor-pointer">
                    {row?.username || "-"}
                </span>
            ),
            width: "120px",
        },
        {
            name: "Franchise Type",
            sortable: true,
            selector: (row) => row?.franchiseType || "-",
            width: "150px",
        },
        {
            name: "City",
            sortable: true,
            selector: (row) => row?.officeCity || row?.residentialCity || "-",
            width: "120px",
        },
        {
            name: "Contact No",
            sortable: true,
            selector: (row) => row?.contactNo || "-",
            width: "130px",
        },
        {
            name: "Status",
            sortable: true,
            selector: (row) => (row?.isActive ? "Active" : "Inactive"),
            cell: (row) => (
                <span
                    className={`text-xs font-semibold ${row?.isActive ? "text-green-600" : "text-red-500"
                        }`}
                >
                    {row?.isActive ? "Active" : "Inactive"}
                </span>
            ),
            width: "100px",
        },
        {
            name: "Verified",
            sortable: true,
            selector: (row) => (row?.verified ? "Yes" : "No"),
            cell: (row) => (
                <span
                    className={`text-xs font-medium ${row?.verified ? "text-green-600" : "text-orange-500"
                        }`}
                >
                    {row?.verified ? "Yes" : "No"}
                </span>
            ),
            width: "100px",
        },
        // {
        //     name: "Details",
        //     cell: (row) => (
        //         <Link to={`/franchise/${row?._id}`}>
        //             <button className="px-2 py-1 text-xs bg-orange-600 text-white rounded-md hover:bg-orange-700 transition">
        //                 View Details
        //             </button>
        //         </Link>
        //     ),
        //     width: "120px",
        // },
        {
            name: "Action",
            cell: (row) => (
                <div className="flex items-center gap-2">
                    {row?.verified ? (
                        <span className="text-green-600 text-xs font-medium">Verified</span>
                    ) : (
                        <button
                            onClick={() => handleVerifyFranchise(row?._id)}
                            disabled={verifyLoading}
                            className="px-2 py-1 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                        >
                            {verifyLoading ? "Verifying..." : "Verify"}
                        </button>
                    )}
                </div>
            ),
            width: "120px",
        },
        {
            name: "View",
            cell: (row) => (
                <Link
                    to="/franchiseprofiledetails" state={{ id: row?._id }}
                    className="text-slate-700 hover:text-slate-900 hover:scale-110 transition-all"
                    title="View Details"
                >
                    <FaEye size={18} className="ms-2" />
                </Link>
            ),
            width: "70px",
        },
        {
            name: "Add Deposite",
            cell: (row) => (
                <button
                    onClick={() => handleOpenModaldeposite(row)}
                    className="text-slate-700 hover:text-slate-900 hover:scale-110 transition-all"
                    title="Add Deposit"
                >
                    <FaPlusCircle size={18} className="ms-2" />
                </button>
            ),
            width: "120px",
        },
    ];


    const handlePagination = (page) => {
        setPage(page?.selected);
    };

    const [openModal, setOpenModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleOpenModaldeposite = (row) => {
        setSelectedRow(row?._id);  // if you want row data inside modal
        setOpenModal(true);
    };

    const handleCloseModaldeposite = () => {
        setOpenModal(false);
        setSelectedRow(null);
    };

    return (
        <div className="w-full px-4 pt-6 pb-10 border border-gray-200 md:rounded-md bg-white">
            {/* Heading */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                <p className="text-lg font-bold text-slate-800">Total Franchise</p>
                <button
                    onClick={() => window.location.reload()}
                    className="flex items-center justify-center gap-2 w-full sm:w-auto px-4 h-7 bg-slate-700 hover:bg-slate-800 text-white text-sm font-semibold rounded-md transition"
                >
                    <FiRefreshCcw className="text-base" />
                    Refresh
                </button>
            </div>

            {/* Form */}
            <div className="grid grid-cols-1 md:grid-cols-4 mb-8 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Customer Name:
                    </label>
                    <input
                        type="text"
                        name="SenderName"
                        value={formData.SenderName}
                        onChange={handleChange}
                        placeholder="Enter Sender name"
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Franchise Name:
                    </label>
                    <input
                        type="text"
                        name="SenderName"
                        value={formData.SenderName}
                        onChange={handleChange}
                        placeholder="Enter Sender name"
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Franchise ID:
                    </label>
                    <input
                        type="text"
                        name="awbNo"
                        value={formData.awbNo}
                        onChange={handleChange}
                        placeholder="Enter AWB number(s)"
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>
                {/* AWB No(s) */} <div> <label className="block text-sm font-medium text-gray-700 mb-1">AWB NO(s):</label> <input type="text" name="awbNo" value={formData.awbNo} onChange={handleChange} placeholder="Enter AWB number(s)" className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none" /> </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        From Date:
                    </label>
                    <input
                        type="date"
                        name="fromDate"
                        value={formData.fromDate}
                        onChange={handleChange}
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        To Date:
                    </label>
                    <input
                        type="date"
                        name="toDate"
                        value={formData.toDate}
                        onChange={handleChange}
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>

                {/* <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        OTP Type:
                    </label>
                    <select
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    >
                        <option value="all">All</option>
                        <option value="booked">Booked Shipment</option>
                        <option value="received">Received Shipment</option>
                        <option value="sorting">Sorting Shipment</option>
                        <option value="in_transit">In Transit Shipment</option>
                        <option value="received_in_transit">Received In-Transit</option>
                    </select>
                </div> */}

                <div className="md:mt-6 mt-3">
                    <button
                        type="button"
                        onClick={handleReset}
                        className="bg-blue-50 text-black hover:bg-blue-100 text-sm font-medium px-5 py-2 rounded-md"
                    >
                        Reset Form
                    </button>
                </div>
            </div>
            {/* <Link
                to="/scanhub"
                className="inline-block bg-orange-600 hover:bg-orange-700 focus:ring-2 focus:ring-orange-400 focus:outline-none text-white font-semibold rounded-md px-5 py-2 transition-colors duration-200 shadow-md mb-3"
            >
                Scan To Sorting
            </Link> */}
            {/* Table */}
            <div className="text-gray-600 grid grid-cols-1">

                <Table
                    columns={orderTableColumns}
                    data={data?.getAllFranchise?.data || []}
                    currentPage={page}
                    totalRecords={data?.getAllFranchise?.count || 0}
                    limit={limit}
                    setLimit={setLimit}
                    setPage={setPage}
                    loading={loading}
                    handlePagination={handlePagination}
                />
            </div>

            {openModal && (
                <FranchiseDepositeAddModal
                    onClose={handleCloseModaldeposite}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                />
            )}

        </div>
    );
};
export default TotalFranchiseAdmin
